// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2C4pN","signatureBlock":"Footer_signatureBlock__J_grD","signature":"Footer_signature__2v4lh"};